export enum PumpTimelineTypes {
  SUMMARY = "Summary",
  DATA = "Data",
  ALERT = "Alert",
  GAP = "Gap",
  SUBGROUP = "SubGroup",
}

// The sum height of SUMMARY, DATA, ALERT, GAP must be equal to full height of the TimeLineVehiclesItem
// 138px (118px + 20px margin-bottom) default height
// 138px (115px + 23px margin-bottom) mobile height
export enum PumpTimelineGroupsHeights {
  SUMMARY = 30,
  DATA = 84,
  ALERT = 10,
  GAP = 14,
  SUBGROUP = 25,
}

export enum PumpStatusTypes {
  OCIOSA = "Ociosa",
  BOMBEANDO = "Bombeando"
}

export enum PumpStatusTypesColors {
  OCIOSA = "#F70700",
  BOMBEANDO = "#8B92BB"
}
